import MD5 from 'crypto-js/md5'

import { fetchUserData } from '@/entities/user/api'

import { getCookie } from '@/shared/lib/utils/common/getCookie'
import { waitForCookie } from '@/shared/lib/utils/cookies/wait-for-cookie'
import { TBitrixInstance } from '@/shared/types/deprecated-types'

/* It's a class for interaction with bitrix live chat. */

interface Service {
	init: (...args: unknown[]) => unknown
	destroy?: (...args: unknown[]) => unknown
}

export class BitrixChat implements Service {
	public _bitrixInstance: TBitrixInstance
	private readonly _bitrixScriptLink: string
	private _bitrixScript: HTMLScriptElement

	constructor(bitrixScriptLink: string) {
		this._bitrixScriptLink = bitrixScriptLink
		this._bitrixScript = null
		this._bitrixInstance = null

		this._setInstance = this._setInstance.bind(this)
	}

	public init() {
		// Setting bitrix chat instance
		window.addEventListener(`onBitrixLiveChat`, this._setInstance)
	}

	public destroy() {
		window.removeEventListener(`onBitrixLiveChat`, this._setInstance)
	}

	public close() {
		if (!this._bitrixInstance) return
		this._bitrixInstance.close()
	}

	public open() {
		console.log('[BitrixChat] open() called, instance:', this._bitrixInstance ? 'exists' : 'null')
		if (!this._bitrixInstance) {
			console.error('[BitrixChat] Cannot open - instance is null. Bitrix widget may not be loaded.')
			return
		}
		this._bitrixInstance.open()
	}

	// @ts-ignore
	public setCustomData(customData) {
		this._bitrixInstance.setCustomData(customData)
	}

	public async setUserRegisterData() {
		if (!getCookie('mindboxDeviceUUID')) {
			await waitForCookie('mindboxDeviceUUID').catch(() => undefined)
		}

		const deviceUUID = getCookie('mindboxDeviceUUID')
		if (!deviceUUID) return

		let data

		try {
			const authToken = getCookie(`ACCESS_TOKEN`)
			const userInfo = await fetchUserData(authToken)

			if (userInfo) {
				data = {
					hash: MD5(deviceUUID).toString(),
					name: userInfo.first_name,
					lastName: userInfo.last_name,
					email: userInfo.user_email ?? ''
				}
			} else {
				data = {
					hash: MD5(deviceUUID).toString(),
					name: 'Неавторизованный пользователь'
				}
			}
		} catch {
			data = {
				hash: MD5(deviceUUID).toString(),
				name: 'Неавторизованный пользователь'
			}
		}

		// @ts-ignore
		this._bitrixInstance.setUserRegisterData(data)
	}

	// @ts-ignore
	private _setInstance(event) {
		this._bitrixInstance = event.detail.widget
		this.setUserRegisterData()
	}
}
